
export const resize = {
  data() {
    return {};
  },

  beforeMount() {
    window.addEventListener("resize", this.tableLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.tableLayout);
  },
  methods: {
    tableLayout(){
        // console.log('mixins方法');
        this.$refs.table.doLayout();
    }
  },
};
